<template>
  <div class="overflow: auto">
    <div class="query-c">
      <Select
        v-model="productId"
        @on-change="changeInput"
        style="width:200px;margin-left: 20px;"
        placeholder="请选择产品"
      >
        <Option v-for="item in ProductData" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <Select
        v-model="type"
        @on-change="changeInput"
        style="width:200px;margin-left: 20px;"
        placeholder="选择订单状态"
      >
        <Option v-for="item in types" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>

      <Input
        v-model="name"
        @input="changeInput()"
        search
        placeholder="输入办卡人姓名"
        style="width: auto;margin-left: 20px;"
      />
      <Input
        v-model="phone"
        @input="changeInput()"
        search
        placeholder="输入办卡人手机号"
        style="width: auto;margin-left: 20px;"
      />
      <Input
        v-model="pincodes"
        @input="changeInput()"
        search
        placeholder="输入办卡人身份证"
        style="width: auto;margin-left: 20px;"
      />
      <Input
        v-model="userNname"
        @input="changeInput()"
        search
        placeholder="输入推荐人姓名"
        style="width: auto;margin-left: 20px;"
      />
      <DatePicker
        type="daterange"
        split-panels
        placeholder="按时间查询"
        style="width: 200px;margin-left:20px"
        @on-change="queryTime"
      ></DatePicker>
    </div>
    <br />
    <Table :content="self" border stripe :columns="columns1" :data="data1"></Table>
    <br />
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "OrderForm",

  data() {
    return {
      modal1: false,
      total: 0,
      time: [],
      phone: "",
      name: "",
      productId: "",
      self: this,
      state: "",
      keyword: "",
      userNname: "",
      pageNow: 1,
      ProductData: [],
      pincodes: "",
      Product: "",
      types: [
        {
          value: "1",
          label: "待确认"
        },
        {
          value: "2",
          label: "已完成"
        },
        {
          value: "3",
          label: "结算额外佣金"
        },
        {
          value: "4",
          label: "已作废"
        }
      ],
      type: "",
      columns1: [
        {
          title: "推荐人",
          align: "center",
          key: "userName"
        },
        {
          title: "进件日期",
          align: "center",
          key: "creationTime"
        },
        {
          title: "产品名称",
          align: "center",
          key: "productName"
        },
        {
          title: "订单状态",
          align: "center",
          key: "state"
        },
        {
          title: "用户姓名",
          align: "center",
          key: "name"
        },
        {
          title: "用户手机号",
          key: "phone",
          align: "center"
        }
      ],
      data1: []
    };
  },

    activated: function() {
     this.getData("");
    this.getProduct();
  },
  methods: {
    getData() {
      api
        .GetAllInformation({
          pageNow: this.pageNow,
          pageSize: "10",
          name: this.name,
          phone: this.phone,
          productId: this.productId,
          pincodes: this.pincodes,
          userNname: this.userNname,
          start: this.time[0],
          end: this.time[1],
          state: this.state
        })
        .then(res => {
          this.total = res.body.data.total;
          this.data1 = res.body.data.list;
          this.data1.forEach(element => {
            if (element.state == 1) {
              element.state = "待确认";
            } else if (element.state == 2) {
              element.state = "已完成";
            } else if (element.state == 3) {
              element.state = "结算额外佣金";
            } else if (element.state == 4) {
              element.state = "已作废";
            }
          });
        });
    },
    changeInput() {
          this.pageNow = 0;
      this.getData();
    },
    getProduct() {
      api
        .ProductSelectAll({
          pageNow: 1,
          pageSize: "1000"
        })
        .then(res => {
          res.body.data.list.forEach(element => {
            this.ProductData.push({
              value: element.id,
              label: element.productName
            });
          });
        });
    },
    queryTime(time) {
      this.time[0] = Date.parse(new Date(time[0])) - 28800000;
      this.time[1] = Date.parse(new Date(time[1])) - 28800000+86400000 ;
      this.getData(this.keyword);
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData(this.keyword);
    }
  }
};
</script>

<style scoped>
.top {
  height: 70px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #aaa;
  margin-bottom: 20px;
}
.ivu-btn-error {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>